<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="项目名称" :value="1"></el-option>
                            <el-option label="项目ID" :value="2"></el-option>
                            <el-option label="发起人ID" :value="3"></el-option>
                            <el-option label="发起人名称" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="raiseType" label="众筹类型">
                    <template slot-scope="scope">
                        {{raiseType.get(scope.row.raiseType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="项目名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link class="ellipsis title" @click="$refs.H5Preview.show('/pages/raise/detail/detail?id='+scope.row.id)">
                            {{scope.row.title}}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="raiseMoneyFormat" label="目标筹款金额" min-width="120"></el-table-column>
                <el-table-column prop="startTime" label="预计开始时间" min-width="150"></el-table-column>
                <el-table-column prop="endTime" label="预计结束时间" min-width="150"></el-table-column>
                <el-table-column prop="promoterUserType" label="发起人身份" min-width="90">
                    <template slot-scope="scope">{{promoterUserType.get(scope.row.promoterUserType)}}</template>
                </el-table-column>
                <el-table-column prop="promoter" label="发起人ID" min-width="90"></el-table-column>
                <el-table-column prop="promoterName" label="发起人名称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="onlineAuditTime" label="发起时间" min-width="150"></el-table-column>

                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/raise/info')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="$utils.have('/raise/audit/pass')"
                            type="text"
                            size="small"
                            icon="el-icon-coordinate"
                            @click="editStatus(scope.row)"
                            >审核</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <audit-edit ref="auditEdit" @onUpdate="getDataList"></audit-edit>
        <H5Preview ref="H5Preview"></H5Preview>
    </div>
</template>
<script>
import AuditEdit from './components/auditEdit';
import H5Preview from '@/components/H5Preview';
const defaultParams = {
    pageNo: 1,
    searchValue: '',
    searchType: 1
}
    export default {
        components:{AuditEdit,H5Preview},
        data(){
            return {
                data: null,
                dataList: null,
                params: {
                    pageNo: parseInt(this.$route.query.pageNo || 1),
                    pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                    searchValue: this.$route.query.searchValue || '',
                    searchType:parseInt(this.$route.query.searchType || 1)
                },
                listLoading: true,
            }
        },
        computed:{
            raiseType(){
                return new Map([
                    [1,'唱片专辑'],
                    [2,'音乐周边'],
                    [3,'其他']
                ])
            },
            promoterUserType(){
                return new Map([
                    [1,'乐迷'],
                    [2,'艺人'],
                    [3,'场地'],
                    [4,'赞助商'],
                    [5,'厂牌']
                ])
            }
        },
        mounted(){
            this.getDataList();
        },
        methods:{
            //获取列表
            getDataList(){
                this.listLoading = true;
                this.$request({
                    url: '/raise/audit/list',
                    method: 'POST',
                    data: this.params
                }).then(res => {
                    const { state, msg, result } = res.data;
                    if( state == 1 && result ){
                        this.data = result;
                        this.dataList = result.result || [];
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            },
            //选择pageSize
            handleSizeChange( e ){
                this.params.pageNo = 1
                this.params.pageSize = e
                this.getDataList()
            },
            //搜索
            search() {
                this.params.pageNo = 1;
                this.getDataList();
            },
            //重置搜索
            reset() {
                this.params = {
                    ...defaultParams,
                    pageSize: this.params.pageSize
                }
                this.getDataList();
            },
            //审核
            editStatus(data){
                this.$refs.auditEdit.show(data);
            },
            //编辑事件
            edit(id) {
                this.$router.push({
                    path: `/raise/project/edit/baseInfo/${id}`,
                    query: {
                        v: this.$utils.uuid(),
                        redirect: this.$utils.objArgs(
                            this.$router.currentRoute.path,
                            this.params
                        ),
                    },
                });
            }   
        }
    }
</script>

<style lang="scss" scoped>

</style>